<template>
  <v-container fluid id="container">
    <v-row justify="center" no-gutters>
      <v-col cols="12">
        <img id="tos-text-img" justify="center" :src="img_src">
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Concept',
  computed: {
    img_src() {
      if (this.$store.state.lang == 'jp') {
        return require('@/assets/concept_jp.png');
      } else {
        return require('@/assets/concept_en.png');
      } 
    }
  }
}
</script>

<style scoped>
#container {
  padding: 0;
  background: black;
}

#tos-text-img {
  width: 100%;
}
</style>
